export default "__VITE_ASSET__B$0Xl_0x__"